import React from 'react';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(4),
}));

const Text = styled(Typography)(({ theme }) => ({
  margin: theme.spacing(1),
}));

export default function Terms(): React.ReactElement {
  return (
    <Container component="article" disableGutters>
      <Text>
        ユーザーは、BAUES（以下「BAUES」といいます。）が提供するサービス「BAUES
        Analysis」（以下「本サービス」といいます。）の利用に際して、以下の利用条件全文を注意してお読みいただいたうえで、本条件に同意いただく必要があります。
      </Text>

      <Title variant="h6">1. 権利帰属等</Title>
      <Text>（a）本サービスに関連する一切の知的財産権及びその他一切の権利は、全てBAUES又はBAUESにその利用を許諾している第三者に帰属します。</Text>
      <Text>（b）ユーザーは、本サービス利用にあたり、本サービスに関連して入力又はアップロード等したデータ（以下「入力データ」といいます。）を本サービスに保存することはできません。</Text>
      <Text>（c）入力データにかかる第三者の権利侵害等を含む第三者に対する侵害その他の紛争については、BAUESは、一切の責任を負わず、ユーザーの責任と負担において処理解決するものとします。</Text>
      <Text>（d）ユーザーは、法令で認められる範囲で、BAUESが次の各号のいずれかを行うことに同意するものとします。</Text>
      <Box sx={{ ml: 4 }}>
        <Text> ① 障害対応及び本サービスの運用・改善のため、入力データ及び処理結果の一部又は全部を利用すること</Text>
        <Text> ② 入力データ又は処理結果を蓄積・加工し、本サービスの全てのユーザーのために用いること</Text>
        <Text> ③ 入力データ及び処理結果を蓄積・加工し、新サービスの開発及び運用の目的で、BAUES及びBAUESが許可する第三者が用いること</Text>
      </Box>

      <Title variant="h6">2. 本サービスの提供等</Title>
      <Text>（a）ユーザーは、本サービスを利用するにあたり、必要なコンピュータ端末、スマートフォンその他通信機器、通信回線、電力等を、ユーザーの費用と責任で用意しなければなりません。</Text>
      <Text>（b）BAUESは、BAUESの都合により、本サービスの内容を変更し、本サービスの全部又は一部を停止、中断又は終了することができます。</Text>

      <Title variant="h6">3. 非保証・責任の制限</Title>
      <Text>（a）本サービスに事実上又は法律上の不具合が生じないことについて、明示的又は黙示的を問わず、BAUESは保証の責任を一切負いません。</Text>
      <Text>（b）BAUESは、本サービスの利用又は利用不能から生じるいかなる損害に関して、一切責任を負わないものとします。</Text>

      <Title variant="h6">4. 管轄裁判所</Title>
      <Text>本サービスに関連して生じる訴訟は、東京地方裁判所を第一審の専属管轄裁判所とします。</Text>

      <Typography sx={{ mt: 6, mb: 4 }}>2021年3月7日制定</Typography>
    </Container>
  );
}
